export default __webpack_public_path__ + "static/media/04.ab965e11.png";